
export default class Stage {

  constructor(root) {
    this.root = root;
    this.slideIndex = 0;
    this.slides = [].slice.call(root.querySelectorAll('.slide'));
    this.interval = parseInt(root.getAttribute('data-interval')) * 1000;
    this.timer = null;
    this.previousButton = null;
    this.nextButton = null;

    this.createNavigationButton = this.createNavigationButton.bind(this);
    this.transitionSlides = this.transitionSlides.bind(this);
    this.setPreviousIndex = this.setPreviousIndex.bind(this);
    this.setNextIndex = this.setNextIndex.bind(this);
    this.handleAnimationEnd = this.handleAnimationEnd.bind(this);
  }

  createNavigationButton(direction) {
    const button = document.createElement('BUTTON');

    button.className = 'navigation-button';
    button.setAttribute('data-direction', direction);
    button.setAttribute('aria-label', `show ${direction} slide`);

    return button;
  }

  transitionSlides(nextIndex, forwards) {
    // Add data attributes to current and next slides to trigger animations
    this.slides[this.slideIndex].setAttribute('data-transition', `current-${forwards ? 'backwards' : 'forwards'}`);
    this.slides[nextIndex].setAttribute('data-transition', `next-${forwards ? 'backwards' : 'forwards'}`);

    // Set z-index higher than other slides for current and next so that slides
    // transition correctly
    this.slides[this.slideIndex].style.zIndex = 3;
    this.slides[nextIndex].style.zIndex = 3;

    // Update slide index to new index
    this.slideIndex = nextIndex;

    window.clearTimeout(this.timer);

    this.timer = window.setTimeout(this.setNextIndex, this.interval);
  }

  setPreviousIndex() {
    const previousIndex = this.slideIndex - 1 > -1 ? this.slideIndex - 1 : this.slides.length - 1;

    this.previousButton.disabled = true;
    this.nextButton.disabled = true;

    this.transitionSlides(previousIndex, false);
  }

  setNextIndex() {
    const nextIndex = this.slideIndex + 1 < this.slides.length ? this.slideIndex + 1 : 0;

    this.previousButton.disabled = true;
    this.nextButton.disabled = true;

    this.transitionSlides(nextIndex, true);
  }

  handleAnimationEnd(event) {
    const slide = event.target;

    this.previousButton.disabled = false;
    this.nextButton.disabled = false;

    slide.removeAttribute('data-transition');
    this.slides
      .filter((slide, index) => index !== this.slideIndex)
      .forEach(slide => slide.style.zIndex = null);
  }

  init() {
    if (this.slides.length > 1 && this.interval) {
      this.previousButton = this.createNavigationButton('previous');
      this.nextButton = this.createNavigationButton('next');

      this.timer = window.setTimeout(this.setNextIndex, this.interval);

      // Reset slides after animation
      this.slides.forEach(slide => {
        slide.addEventListener('animationend', this.handleAnimationEnd);
      });

      this.previousButton.addEventListener('click', this.setPreviousIndex);
      this.nextButton.addEventListener('click', this.setNextIndex);

      this.root.appendChild(this.previousButton);
      this.root.appendChild(this.nextButton);
    }
  }

};



// WEBPACK FOOTER //
// ./components/stage.js